import { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import './Layout.css';
import '../pages/MenuLanding.css';

const Layout = ({ children }) => {
  const { user, logout } = useContext(AuthContext);
  const { cartCount, cartTotalWithoutFee, belowMinimum, hasExemptItem, minOrder } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const showCheckoutBar = cartCount > 0
    && location.pathname !== '/cart'
    && location.pathname !== '/checkout';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const menuItems = [
    { path: '/home', label: 'Home', icon: '🏠' },
    { path: '/categories', label: 'Categories', icon: '📦' },
    { path: '/about-us', label: 'About Us', icon: '🏢' },
    { path: '/cart', label: 'Cart', icon: '🛒' },
    { path: '/account', label: 'Account', icon: '👤' }
  ];

  // Unauthenticated: slim nav (same style as MenuLanding) with back button
  if (!user) {
    return (
      <div className="layout-container">
        <nav className="sd-nav">
          <div className="sd-nav-logo" onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
            <img src="/logo.webp" alt="The New Luxury" className="sd-nav-logo-img" />
          </div>
          <div className="sd-nav-links">
            <button className="sd-nav-link" onClick={() => navigate(-1)}>
              ← Back
            </button>
          </div>
        </nav>

        <main className="main-content">
          {children}
        </main>

        {showCheckoutBar && (
          <div
            className="checkout-floater"
            onClick={() => navigate('/quick-register')}
          >
            <span className="checkout-floater-label">
              {belowMinimum && !hasExemptItem && (
                <span className="checkout-floater-subfee">Add ₹{(minOrder - cartTotalWithoutFee).toFixed(0)} for free delivery</span>
              )}
              <span>Proceed to Checkout</span>
            </span>
            <span className="checkout-floater-badge">{cartCount} item{cartCount !== 1 ? 's' : ''}</span>
            <span className="checkout-floater-arrow">→</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="layout-container">
      {/* Top Navigation Bar - Desktop */}
      <nav className="top-navbar">
        <div className="navbar-brand">
          <img src="/logo.webp" alt="The New Luxury" className="navbar-logo" />
        </div>

        <div className="navbar-menu">
          {menuItems.map((item) => (
            <button
              key={item.path}
              className={`nav-item ${isActive(item.path)}`}
              onClick={() => item.url ? window.open(item.url, '_blank') : navigate(item.path)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </div>

        <div className="navbar-user">
          <span className="user-name">{user?.name || user?.username || 'User'}</span>
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </nav>

      {/* Main Content */}
      <main className="main-content">
        {children}
      </main>

      {/* Checkout floating bar */}
      {showCheckoutBar && (
        <div
          className="checkout-floater"
          onClick={() => navigate('/checkout')}
        >
          <span className="checkout-floater-label">
            {belowMinimum && !hasExemptItem && (
              <span className="checkout-floater-subfee">Add ₹{(minOrder - cartTotalWithoutFee).toFixed(0)} for free delivery</span>
            )}
            <span>Proceed to Checkout</span>
          </span>
          <span className="checkout-floater-badge">{cartCount} item{cartCount !== 1 ? 's' : ''}</span>
          <span className="checkout-floater-arrow">→</span>
        </div>
      )}

      {/* Bottom Navigation Bar - Mobile */}
      <nav className="bottom-navbar">
        {menuItems.map((item) => (
          <button
            key={item.path}
            className={`bottom-nav-item ${isActive(item.path)}`}
            onClick={() => item.url ? window.open(item.url, '_blank') : navigate(item.path)}
          >
            <span className="bottom-nav-icon">{item.icon}</span>
            <span className="bottom-nav-label">{item.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default Layout;
